import React from 'react';
import UserActions from 'actions/UserActions.js';

export default class SharedCalendarRecipient extends React.Component {
  constructor(props) {
    super(props);
  }

  removeSharedCalendar() {
    UserActions.removeSharedCalendar(this.props.recipient.id);
  }

  render() {
    return (
      <div className="recipientRow">
        <span>{this.props.recipient.email}</span>
        <span onClick={this.removeSharedCalendar.bind(this)} className="removeSharedCalendar">
          x
        </span>
      </div>
    );
  }
}
